/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Încărcare...',
	'dlg_close': 'Închidere',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Anulare',
	'dlg_back': 'Deplasare înapoi',
	'dlg_done': 'Gata',

	// Slider
	'sliderRegionLabel': 'Control slider, utilizaţi săgeţile stânga şi dreapta pentru a muta handle-urile slider-ului',
	'sliderHandleLabel': 'Handle glisor',
	'a11ySliderHandleLabel': 'Handle glisor %{sliderValue}',
	'sliderInputLabel': 'valoare',

	// Side bar
	'sidebarAdd': 'Adăugare',
	'clearTextFilterValue': 'Curăţare',
	'missingDataSetData': 'Datele pentru acest set de date nu sunt disponibile. Reîmprospătaţi setul de date sau contactaţi-vă administratorul pentru accesul la sursă.',

	// Toolbar
	'toolbarRegionLabel': 'Bară de unelte',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Familie de fonturi',
	'fontSizeSelect': 'Mărime font',
	'fontColorSelect': 'Culoare',
	'fontStyle': 'Stil',
	'colorPickerTitle': 'Selectarea unei culori',
	'bold': 'Aldin',
	'italic': 'Cursiv',
	'underline': 'Subliniere',
	'fontAlignment': 'Aliniere',
	'justifyLeft': 'Aliniere la stânga',
	'justifyCenter': 'Aliniere la centru',
	'justifyRight': 'Aliniere la dreapta',
	'insertOrderedList': 'Listă ordonată',
	'insertUnorderedList': 'Listă neordonată',
	'fontColorPicker': 'Selector de culoare',
	'textWrap': 'Încadrare text',
	'restore': 'Restaurare valori implicite',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Număr de rezultate (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Procent (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Opţiune Vârf sau sfârşit:',
	'topbottomOptionLabel': 'Afişare',
	'searchByLabel': 'De',
	'searchNoMatches': 'Nu s-a găsit nici o potrivire',
	'topbottomRankColumnLabel': 'Adăugare în tabel coloană de rang',
	'topbottomNone': 'Fără',
	'topCount': 'Număr primele',
	'topPercent': 'Primele %',
	'bottomCount': 'Număr ultimele',
	'bottomPercent': 'Ultimele %',
	'searchColumn': 'Găsirea unei coloane',
	'searchColumnAriaLabel': 'Găsiţi o coloană. Tastaţi numele coloanei de căutat, apoi utilizaţi săgeata în jos pentru a găsi coloana într-o listă',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Resetare',

	// Format
	'formatAuto': 'Automat',
	'formatConvertPercent': 'Convertire zecimale la procentaj',
	'formatAbbreviate': 'Abreviere',
	'formatUseGrouping': 'Utilizare separator de mii',
	'dateStyle': 'Stil de dată',
	'dateTimeStyle': 'Stil dată-oră',
	'formatMissingValueCharactersInfo': 'Caractere valoare lipsă specifică caracterele care vor fi afişate atunci când valoarea lipseşte.',
	'currencySymbolLabel': 'Simbol monetar',
	'customSymbolPlaceholder': 'Adăugare simbol',
	'customSymbolLabelInfo': 'Specifică un caracter sau caractere pentru utilizarea ca simbol personalizat. Acest simbol va preceda numărul şi orice semn.',
	'numberLabel': 'Etichetă număr',
	'numberPositionLabel': 'Poziţie etichetă',
	'numberLabelInfo': 'Specifică o etichetă pentru numărul formatat şi plasat ca prefix sau sufix în funcţie de poziţia etichetei.',
	'nullValueDefault': '<implicit>',
	'nullValueContent': '(nici o valoare)',
	'default': 'Implicit',
	'beginning': 'Început',
	'end': 'Sfârşit',
	'formatLabel': 'Selectare format',

	// More data indicator
	'moreDataIndicator': 'Datele dumneavoastră au fost decupate la %{threshold} articole. Aplicaţi un filtru pentru a afişa mai puţin.',

	// Expanded View / Focus mode
	'evCollapse': 'Restrângere',
	'duplicate': 'Duplicare',
	'copyOf': 'Copiere %{name}',
	'unableToDuplicateBoard': 'Nu se poate duplica "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Nu putem încărca obiectele.',

	// Custom widgets
	'customWidget': 'Widget personalizat'
});
